import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import axios from 'axios'
import i18n from './lang'
import Vant from 'vant'
import 'vant/lib/index.css'
import { globalConfigMixin } from './mixin/globalConfig'
import SiteType from './mixin/siteType'
import 'beautify-scrollbar/dist/index.css'
import VueGtag from 'vue-gtag'
import siteType from './configs/siteType'
const htmlFontSize = () => {
  if (parseInt(document.documentElement.style.fontSize.replace('px', '')) > 54) {
    const autoHeight = parseInt(window.innerHeight * 750 / 1334 / 10)
    if (autoHeight > 54) {
      document.documentElement.style.fontSize = '54px'
    } else {
      document.documentElement.style.fontSize = autoHeight + 'px'
    }
  }
}

htmlFontSize()
window.addEventListener('resize', function () {
  htmlFontSize()
})

Vue.mixin(globalConfigMixin)
Vue.mixin(SiteType)

Vue.use(VueGtag, {
  config: {
    id: 'G-ZN48Q4QDQ9',
    pageTrackerTemplate (to) {
      return {
        page_title: siteType.GetSiteType() === siteType.SITE_TYPE_NUTS ? 'nutspoker_club' : 'kkpoker_club',
        page_path: to.path
      }
    }
  }
}, router)

// Vue.use(V2Table)

axios.interceptors.request.use(config => {
  // 增加时间戳
  config.params = {
    _t: Date.parse(new Date()) / 1000,
    ...config.params
  }

  return config
}, error => {
  // 发送请求错误操作
  return Promise.reject(error)
})

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.VUE_APP_AXIOS
Vue.prototype.$axios = axios
Vue.use(Vant)
new Vue({
  router,
  store,
  i18n,
  data: () => {
    return {
      currentType: 'curacao'
    }
  },
  render: h => h(App)
}).$mount('#app')
